export const FINAL_ADMINISTRATION_FEE_MAX = 15;
